import React from 'react';
import { View, Text, Pressable, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Paprika, PaprikaFreshness } from '../../styles/theme';

interface Props {
  count: number;
  names: string[];
  onPress: () => void;
}

export function CookStrip({ count, names, onPress }: Props) {
  const { t } = useTranslation();
  const f = PaprikaFreshness.urgent;

  return (
    <Pressable onPress={onPress} style={[styles.strip, { backgroundColor: f.bg, borderColor: f.soft }]}>
      <Ionicons name="flame" size={16} color={f.text} style={styles.flame} />
      <View style={styles.content}>
        <Text style={[styles.title, { color: Paprika.textPrimary }]} numberOfLines={1}>
          {t('pantry.cook.stripTitle', { count })}
        </Text>
        <Text style={[styles.items, { color: Paprika.textSecondary }]} numberOfLines={1}>
          {names.slice(0, 3).join(' · ') || t('pantry.cook.stripEmpty')}
        </Text>
      </View>
      <Ionicons name="chevron-forward" size={16} color={f.text} style={styles.chevron} />
    </Pressable>
  );
}

const styles = StyleSheet.create({
  strip: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
    paddingVertical: 11,
    paddingHorizontal: 13,
    borderRadius: 14,
    borderWidth: 1,
  },
  flame: {
    marginRight: 4,
  },
  content: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 12.5,
    lineHeight: 16,
  },
  items: {
    fontFamily: 'Inter-Regular',
    fontSize: 11,
    marginTop: 2,
    lineHeight: 14,
  },
  chevron: {
    marginLeft: 8,
  },
});
